import api from '../api';

const ONBOARDING_CONTENT_LIST = api.events.onboardingContent.actionSuccess;

const defaultState = { list: [] };

export default (state = defaultState, action) => {
  switch (action.type) {
    case ONBOARDING_CONTENT_LIST:
      return { ...state, list: action.data };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/onboardingContent.js